import axiosInstance from "../libs/axiosInstance";

/**
 * Authenticate user with Google OAuth
 * @param {string} idToken - Google ID token from OAuth response
 * @returns {Promise<{user: object, profile: object, token: string}>}
 */
export const googleLogin = async (idToken) => {
  try {
    const response = await axiosInstance.post('/account/google-oauth/', {
      id_token: idToken,
    });
    return response.data;
  } catch (error) {
    console.error('Google login failed:', error);
    throw error;
  }
};
